import React from 'react';
import ReactDOM from 'react-dom/client';
import './auth/legacyAuth0Cleanup'; // runs side-effect on import, must be before any auth imports
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './designSystem.css';
import './index.css';

// Suppress harmless ResizeObserver errors during route transitions
// These errors occur when navigating to/from Stripe checkout and are completely harmless
const resizeObserverLoopErrRe = /ResizeObserver loop limit exceeded|ResizeObserver loop completed with undelivered notifications/;

// Suppress console.error logs
const originalError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && !resizeObserverLoopErrRe.test(args[0])) {
    originalError(...args);
  }
};

// Suppress runtime errors at the window level
const originalErrorHandler = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (typeof message === 'string' && resizeObserverLoopErrRe.test(message)) {
    return true; // Prevent default error handling
  }
  if (originalErrorHandler) {
    return originalErrorHandler(message, source, lineno, colno, error);
  }
  return false;
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
